import { FC } from 'react';

interface BadgeStatusProps {
  color: 'blue' | 'green' | 'red' | 'orange' | 'gray' | 'yellow' | 'purple' | 'indigo' | 'pink';
  text: string;
}

const BadgeStatus: FC<BadgeStatusProps> = ({ color, text }) => {
  const colorClasses: { [key: string]: string } = {
    blue: 'bg-blue-500 text-white',
    green: 'bg-green-500 text-white',
    red: 'bg-red-500 text-white',
    orange: 'bg-orange-500 text-white',
    gray: 'bg-gray-500 text-white',
    yellow: 'bg-yellow-500 text-black',
    purple: 'bg-purple-500 text-white',
    indigo: 'bg-indigo-500 text-white',
    pink: 'bg-pink-500 text-white',
  };

  const badgeClass = `h-6 px-2 py-1 inline-flex items-center rounded-lg text-xs font-light ${colorClasses[color]}`;

  return (
    <span className={badgeClass}>
      {text}
    </span>
  );
};

export default BadgeStatus;
